import React from 'react';
import { BodyText, TertiaryButton } from '@kallidus/common';
import clsx from 'clsx';
import { string, bool } from 'prop-types';
import './InlineTextLink.less';

const InlineTextLink = ({ inText = true, className, inheritColor, noTopSpacer = false, ...props }) => {
  const fullClassName = clsx(className, 'inline-text-link', inheritColor && 'inherit-color');
  return inText ? (
    <TertiaryButton className={fullClassName} {...props} />
  ) : (
    <BodyText noTopSpacer={noTopSpacer}>
      <TertiaryButton className={fullClassName} {...props} />
    </BodyText>
  );
};

export default InlineTextLink;

InlineTextLink.propTypes = {
  className: string,
  /** If true, then the link will appear the same colour as the parent element */
  inheritColor: bool,
  /** If true the link will appear inline with text */
  inText: bool,
  /** If true the top spacing will be removed. Default is false */
  noTopSpacer: bool,
};
